import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { getAccessTokenDecoded, logout, isAuthenticated } from 'core/utils/auth';
import menu from 'core/assets/images/menu.png';
import './styles.scss';

const Navbar = () => {
    const [drawerActive, setDrawerActive] = useState(false);
    const [currentUser, setCurrentUser] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    const isLandingPage = location.pathname === '/fastlimp';

    useEffect(() => {
        const currentUserData = getAccessTokenDecoded();
        setCurrentUser(currentUserData.user_name);
    }, [location]);

    const handleLogout = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        logout();
        navigate('/auth/login');
    };

    if (isLandingPage) {
        return (
            <nav className="navbar navbar-expand-md navbar-light landing-nav">
                <div className="container-fluid">
                    <Link to="/fastlimp" className="navbar-brand">
                        <img 
                            src={require('core/assets/images/fastlimp-logo.png')} 
                            alt="Fast Limp" 
                            className="landing-logo" 
                        />
                    </Link>
                </div>
            </nav>
        );
    }

    return (
        <nav className="navbar navbar-expand-md navbar-dark bg-primary main-nav">
            <div className="container-fluid">
                <Link to="/" className="navbar-brand">
                    <h4>InstaCatalog</h4>
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#dscatalog-navbar"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="dscatalog-navbar">
                    <ul className="navbar-nav offset-md-2 main-menu">
                        <li>
                            <NavLink to="/" end>
                                HOME
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/products">
                                CATÁLOGO
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/admin">
                                ADMIN
                            </NavLink>
                        </li>
                    </ul>
                </div>

                <div className="nav-login-logout">
                    {currentUser && (
                        <>
                            <span className="nav-username">
                                {currentUser}
                            </span>
                            <a href="#logout" onClick={handleLogout}>
                                LOGOUT
                            </a>
                        </>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;